<template>
    <div>
      <component :is="currentPage"></component>
    </div>
  </template>
  
  <script>
  import YouthProtectionZHCN from './zh-CN/YouthProtection.vue';
  import YouthProtectionEN from './en/YouthProtection.vue';
  
  export default {
    data() {
      return {
        currentPage: null,
      };
    },
    created() {
      const userLang = navigator.language || 'en';  // 获取浏览器的语言
      if (userLang.startsWith('zh')) {
        this.currentPage = YouthProtectionZHCN;  // 如果是中文，加载中文版页面
      } else {
        this.currentPage = YouthProtectionEN;  // 如果是英文，加载英文版页面
      }
    },
  };
  </script>


// WEBPACK FOOTER //
// src/components/YouthProtection.vue